import { render, staticRenderFns } from "./posProduct.vue?vue&type=template&id=08e70088&scoped=true&"
import script from "./posProduct.vue?vue&type=script&lang=js&"
export * from "./posProduct.vue?vue&type=script&lang=js&"
import style0 from "./posProduct.vue?vue&type=style&index=0&id=08e70088&prod&scoped=true&lang=css&"
import style1 from "./posProduct.vue?vue&type=style&index=1&id=08e70088&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e70088",
  null
  
)

export default component.exports